module.exports = {
  company: {
    promo: "promo",
    voucher: "voucher",
  },
  invoice: {
    application: "application",
    company: "company",
    client: "client",
  },
  poi: {
    application: "application",
    company: "company",
    client: "area",
  },
  promo: {
    application: "application",
    company: "company",
    zoneOut: "zoneOut",
  },
  subscriber: {
    application: "application",
    company: "company",
  },
  trip: {
    organization: "organization",
    application: "application",
    company: "company",
    client: "client",
    trip: "trip",
    promo: "promo",
    poi: "poi",
    area: "area",
    voucher: "voucher",
    taxProfile: "taxProfile",
    transaction: "transaction",
    payment: "payment",
    trustedPeople: "trustedPeople"
  },
  user: {
    taxProfile: "taxProfile",
    device: "device",
    originAddress: "originAddress",
    picture: "picture",
  },
  voucher: {
    application: "application",
    company: "company",
    client: "client",
  },
};
